import React from 'react';
import { useDashboardTranslation } from '../../i18n';
import type { WidgetPresentationType } from '../../types';
import { WIDGET_TYPE_CONFIG } from '../../utils/widgetTypeConfig';

interface Step3PresentationTypeProps {
  selectedTipo: WidgetPresentationType;
  onSelect: (tipo: WidgetPresentationType) => void;
}

// Solo los tipos creables desde el Builder (excluye image y custom que requieren componente propio)
const SELECTABLE_TYPES: WidgetPresentationType[] = [
  'kpi', 'chart_bar_vertical', 'chart_bar_horizontal', 'chart_line', 'chart_donut', 'table',
];

const TIPOS = WIDGET_TYPE_CONFIG.filter(t => SELECTABLE_TYPES.includes(t.id));

export const Step3PresentationType: React.FC<Step3PresentationTypeProps> = ({
  selectedTipo,
  onSelect,
}) => {
  const { t } = useDashboardTranslation();
  return (
    <div className="max-w-2xl mx-auto space-y-6">
      <div>
        <h3 className="text-lg font-semibold text-gray-800">{t('dashboard.builder.step3.title')}</h3>
        <p className="text-sm text-gray-500 mt-1">{t('dashboard.builder.step3.subtitle')}</p>
      </div>

      <div className="grid grid-cols-3 gap-3">
        {TIPOS.map(tipo => {
          const isActive = selectedTipo === tipo.id;
          return (
            <button
              key={tipo.id}
              type="button"
              onClick={() => onSelect(tipo.id)}
              className={`flex flex-col items-center gap-2 p-4 rounded-lg border-2 transition-all text-left ${
                isActive
                  ? 'border-blue-500 bg-blue-50 text-blue-700'
                  : 'border-gray-200 text-gray-600 hover:border-blue-300 hover:bg-blue-50/30 bg-white'
              }`}
            >
              <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${
                isActive ? 'bg-blue-100' : 'bg-gray-100'
              }`}>
                <tipo.icon className={`w-5 h-5 ${isActive ? 'text-blue-600' : 'text-gray-500'}`} />
              </div>

              <div>
                <div className={`text-sm font-semibold ${isActive ? 'text-blue-700' : 'text-gray-800'}`}>
                  {tipo.label}
                </div>
                <div className="text-[11px] text-gray-400 mt-0.5 leading-tight">
                  {tipo.description}
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};
